module.exports = __webpack_public_path__ + "img/principles-bkg.57a95dba.jpg";